import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(
    private apiService: ApiService
  ) { }

  getUserTypeFromSessionStorage(): number {
    let ssUserType: number;
    try {
      ssUserType = Number(localStorage.getItem('userType'));
    } catch {
      return -1;
    }

    return ssUserType ? ssUserType : -1;
  }

}
